module.exports = __webpack_public_path__ + "6c3a943466c5cdf01967efe7e9d5ad82.pdf";